<template>
	<div>
		
		<div
			v-if="isLoadingProfiloCliccatore || isLoading"
			style="background-color: white"
			class="pa-3 mb-6"
		>
			<v-progress-linear
				indeterminate
				color="secondary"
			></v-progress-linear>
		</div>
		
		<div
			v-else
			style="background-color: white"
			class="pa-3 mb-6"
		>
			<v-row class="justify-space-between">
				<v-col cols="8" class="d-flex flex-column">
					<div class="d-flex justify-space-between mb-8 mx-3">
						<div class="mb-6 mr-6" style="font-size: 14px;">
							<div class="font-weight-bold" style="font-size: 18px">{{ datiProfiloCliccatore.nome_bando }}</div>
							<div class="font-weight-medium">Data Click Day:
								<span :style="`color:${scdColor};`">{{ computedDateTimeWithoutSeconds(datiProfiloCliccatore.data_ora_clickday) || 'Data non disponibile' }}</span>
							</div>
						</div>
						
						<div style="font-size: 14px;">
							<div class="font-weight-medium">Compenso base per vittoria:
								<span :style="`color:${scdColor};`">{{ datiProfiloCliccatore.compenso_vittoria }}€</span>
							</div>
							<div class="font-weight-medium">Punti in classifica per vittoria:
								<span :style="`color:${scdColor};`">{{ datiProfiloCliccatore.punti_clickday_vinto }}</span>
							</div>
							<div class="font-weight-medium">Punti in classifica per perdita:
								<span :style="`color:${scdColor};`">{{ datiProfiloCliccatore.punti_clickday_perso }}</span>
							</div>
						</div>
						
						<div class="mr-3 font-weight-medium">
							<div class="font-weight-bold" style="background-color: #bfd0ea; padding: 5px 15px;">Game Day del Bando</div>
							<table style="width: 100%; font-size: 14px; background-color: #e3ebf6; padding: 5px 15px;">
								<tr>
									<td>Partecipati</td>
									<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">
										{{ datiProfiloCliccatore.gameday_partecipati_bando_attuale }}
									</span></td>
								</tr>
								<tr>
									<td>Vinti</td>
									<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">
										{{ datiProfiloCliccatore.gameday_vinti_bando_attuale }}
									</span></td>
								</tr>
								<tr>
									<td>Persi</td>
									<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">
										{{ datiProfiloCliccatore.gameday_persi_bando_attuale }}
									</span></td>
								</tr>
								<tr>
									<td>Abbandonati</td>
									<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">
										{{ datiProfiloCliccatore.gameday_abbandonati_bando_attuale }}
									</span></td>
								</tr>
							</table>
						</div>
					</div>
					
					<!--<div class="d-flex align-center  mb-6">-->
					<div class="d-flex align-center mb-6 ml-3">
						<div class="_box-profilo-cliccatore">
							<div>Simulazioni totali</div>
							<span :style="`color:${scdColor}`">
								{{ datiProfiloCliccatore.simulazioni_totali }}
							</span>
						</div>
						<div class="_box-profilo-cliccatore">
							<div>
								Abbandonate su ultime {{ datiProfiloCliccatore.minimo_simulazioni_selezione }}
								<v-tooltip bottom close-delay="1000">
									<template v-slot:activator="{ on }">
										<v-icon small v-on="on" color="#6D94CD">mdi-information</v-icon>
									</template>
									<span>
										Scopri di più leggendo il consiglio "Simulazioni abbandonate"
										<!-- I link non sembrano essere funzionanti nei tooltip -->
										<!-- <a href="/home#/gaming-consigli" target="_blank" style="color: inherit; text-decoration: underline;">
										</a> -->
									</span>
								</v-tooltip>
							</div>
							<span :style="`color:${scdColor}`">
								{{ datiProfiloCliccatore.simulazioni_abbandonate_perc }}% ({{ datiProfiloCliccatore.simulazioni_abbandonate }})
							</span>
						</div>
						<div class="_box-profilo-cliccatore">
							<div class="d-flex">
								<div>Win Score attuale</div>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-icon
											small
											color="primary"
											class="ml-1"
											v-bind="attrs"
											v-on="on"
										>
											mdi-information
										</v-icon>
									</template>
									<span>Mostra la percentuale di simulazioni vinte tra le ultime {{ datiProfiloCliccatore.minimo_simulazioni_selezione }} se la selezione è stata superata.</span>
								</v-tooltip>
							</div>
							<template>
								<span :style="`color:${scdColor}`">{{ datiProfiloCliccatore.selezione_superata ? datiProfiloCliccatore.punteggio_attuale + " %" : '-' }}</span>
								<small v-if="datiProfiloCliccatore.simulazioni_mancanti > 0">(mancano ancora {{ datiProfiloCliccatore.simulazioni_mancanti }} simulazioni)</small>
							</template>
						</div>
						<div class="_box-profilo-cliccatore">
							<div class="d-flex">
								<div>Win Score migliore</div>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-icon
											small
											color="primary"
											class="ml-1"
											v-bind="attrs"
											v-on="on"
										>
											mdi-information
										</v-icon>
									</template>
									La soglia in percentuale del Win Score migliore una volta raggiunta non può più diminuire.
								</v-tooltip>
							</div>
							<template>
								<span :style="`color:${scdColor}`">{{ datiProfiloCliccatore.selezione_superata ? datiProfiloCliccatore.miglior_punteggio + " %" : '-' }}</span>
								<small v-if="datiProfiloCliccatore.simulazioni_mancanti > 0">(mancano ancora {{ datiProfiloCliccatore.simulazioni_mancanti }} simulazioni)</small>
							</template>
						</div>
						<div class="_box-profilo-cliccatore">
							<div class="d-flex">
								<div class="mr-2">Stato selezione</div>
								<v-tooltip bottom :color="scdColor">
									<template v-slot:activator="{ on }">
										<v-icon :color="scdColor" small dark v-on="on">info</v-icon>
									</template>
									<span>Per superare la selezione devi aver raggiunto almeno una volta {{ datiProfiloCliccatore.minimo_win_score_selezione?.toString()[0] == '8' ? "l'" : 'il' }} {{ datiProfiloCliccatore.minimo_win_score_selezione }}% di simulazioni vinte nelle ultime {{ datiProfiloCliccatore.minimo_simulazioni_selezione }}</span>
								</v-tooltip>
							</div>
							<template>
								<small v-if="datiProfiloCliccatore.simulazioni_mancanti > 0">(mancano ancora {{ datiProfiloCliccatore.simulazioni_mancanti }} simulazioni)</small>
								<span v-else :style="`color:${scdColor}`">{{ datiProfiloCliccatore.selezione_superata ? 'Superata' : 'Non superata' }}</span>
							</template>
						</div>
					</div>
					<!--</div>-->
					
					<v-simple-table>
						<template v-slot:default>
							<thead>
							<tr>
								<th class="text-left"></th>
								<th class="text-left">
									Base
								</th>
								<th
									v-if="datiProfiloCliccatore.compenso_selezione !== null"
									class="text-left"
								>
									Selezione
								</th>
								<th class="text-left">
									Game Day
								</th>
								<th class="text-left">
									Vittorie degli amici
								</th>
								<th class="text-left" style="background-color: #e2eaf5">
									TOTALE
								</th>
							</tr>
							</thead>
							<tbody>
							<tr>
								<td class="font-weight-medium">Compenso in caso di vittoria</td>
								<td class="font-weight-medium" :style="`color:${scdColor};`">{{ datiProfiloCliccatore.compenso_vittoria }}€</td>
								<td
									v-if="datiProfiloCliccatore.compenso_selezione !== null"
									class="font-weight-medium"
									:style="`color:${scdColor};`"
								>
									{{ datiProfiloCliccatore.selezione_superata ? datiProfiloCliccatore.compenso_selezione : 0 }}€
								</td>
								<td class="font-weight-medium" :style="`color:${scdColor};`">
									<span v-if="datiProfiloCliccatore.gamedays_abilitati">
										{{ datiProfiloCliccatore.somma_compensi_gamedays_vinti_e_persi_clickday_vinto }}€
									</span>
									<span v-else>-</span>
								</td>
								<td class="font-weight-medium" :style="`color:${scdColor};`">
									<span v-if="datiProfiloCliccatore.bonus_vittorie_amici_abilitati">
										{{ datiProfiloCliccatore.somma_compensi_per_amici_vincenti_esiti_definitivi }}€
									</span>
									<span v-else>-</span>
								</td>
								<td class="font-weight-medium" :style="`color:${scdColor}; background-color: #e2eaf5;`">
									{{ datiProfiloCliccatore.totale_compenso_automatico_vittoria_esiti_definitivi }}€
								</td>
							</tr>
							<tr>
								<td class="font-weight-medium">Compenso in caso di perdita/non assegnato</td>
								<td class="font-weight-medium" :style="`color:${scdColor};`">
									{{ datiProfiloCliccatore.compenso_perdita }}€
								</td>
								<td
									v-if="datiProfiloCliccatore.compenso_selezione !== null"
									class="font-weight-medium"
									:style="`color:${scdColor};`"
								>
									{{ datiProfiloCliccatore.selezione_superata ? datiProfiloCliccatore.compenso_selezione : 0 }}€
								</td>
								<td class="font-weight-medium" :style="`color:${scdColor};`">
									<span v-if="datiProfiloCliccatore.gamedays_abilitati">
										{{ datiProfiloCliccatore.somma_compensi_gamedays_vinti_e_persi_clickday_perso }}€
									</span>
									<span v-else>-</span>
								</td>
								<td class="font-weight-medium" :style="`color:${scdColor};`">
									<span v-if="datiProfiloCliccatore.bonus_vittorie_amici_abilitati">
										{{ datiProfiloCliccatore.somma_compensi_per_amici_vincenti_esiti_definitivi }}€
									</span>
									<span v-else>-</span>
								</td>
								<td class="font-weight-medium" :style="`color:${scdColor}; background-color: #e2eaf5;`">
									{{ datiProfiloCliccatore.totale_compenso_automatico_perdita_esiti_definitivi }}€
								</td>
							</tr>
							</tbody>
						</template>
					</v-simple-table>
				</v-col>
				
				<!--max-width:259px-->
				<v-col cols="4">
					<div class="d-flex flex-column scatola-azzurra mb-4">
						<div class="d-flex align-center">
							<!--<v-skeleton-loader class="skeleton_loader_esito_clickday mb-2" v-if="isLoadingProfilo" type="avatar"></v-skeleton-loader>-->
							<!--<v-img class="mb-2" v-else-if="!isLoadingProfilo" :src="urlImmagineEsitoClickday" max-height="80" contain></v-img>-->
							<div
								style="font-weight:700; font-size:20px;"
								class="flex-grow-1"
							>
								<v-row v-if="!datiProfiloCliccatore.iscritto_al_clickday_attuale" :style="`color: ${scdColorDarkBlue}`" class="align-center no-gutters">
									<v-col cols="1" class="mr-3"><v-icon class="icon-outlined" size="20" :color="scdColorDarkBlue">mdi-account-minus-outline</v-icon></v-col>
									<v-col><div>Non sei iscritto a questo Click Day</div></v-col>
								</v-row>
								<v-row v-else-if="datiProfiloCliccatore.esito_clickday === 'Iscritto'" :style="`color:${scdOrange};`" class="align-center no-gutters">
									<v-col cols="1" class="mr-3"><v-icon class="icon-outlined" :style="`border-color: ${scdOrange}`" size="20" :color="scdOrange">mdi-account-plus-outline</v-icon></v-col>
									<v-col><div>Sei iscritto a questo Click Day</div></v-col>
								</v-row>
								<v-row v-else-if="datiProfiloCliccatore.esito_clickday === 'In attesa di esito'" :style="`color:${scdColorDarkBlue};`" class="align-center no-gutters">
									<v-col cols="1" class="mr-3">
										<v-icon class="icon-outlined" size="20" :color="scdColorDarkBlue">hourglass_bottom</v-icon>
									</v-col>
									<v-col><div>In attesa di esito</div></v-col>
								</v-row>
								<v-row v-else-if="datiProfiloCliccatore.esito_clickday === 'Vincente' || datiProfiloCliccatore.esito_clickday === 'Vincente Esiti Definitivi'" :style="`color:${scdGreen};`" class="align-center no-gutters">
									<v-col cols="1" class="mr-3">
										<v-icon class="icon-outlined" size="20" :style="`border-color: ${scdGreen}`" :color="scdGreen">mdi-trophy-variant-outline</v-icon>
									</v-col>
									<v-col><div>Hai vinto!</div></v-col>
								</v-row>
								<v-row v-else-if="datiProfiloCliccatore.esito_clickday === 'Non assegnato'" :style="`color:${scdGreen};`" class="align-center no-gutters">
									<v-col cols="1" class="mr-3">
										<v-icon class="icon-outlined" size="20" :style="`border-color: ${scdGreen}`" :color="scdGreen">military_tech</v-icon>
									</v-col>
									<v-col><div>Click non assegnato</div></v-col>
								</v-row>
								<v-row v-else-if="datiProfiloCliccatore.esito_clickday === 'Non vincente'" :style="`color:${scdLightRed};`" class="align-center no-gutters">
									<v-col cols="1" class="mr-3">
										<v-icon class="icon-outlined" size="20" :style="`border-color: ${scdLightRed}`" :color="scdLightRed">close</v-icon>
									</v-col>
									<v-col><div>Click non vincente</div></v-col>
								</v-row>
								<v-row v-else-if="datiProfiloCliccatore.esito_clickday === 'Abbandonato / Screenshot mancante'" :style="`color:${scdRed};`" class="align-center no-gutters">
									<v-col cols="1" class="mr-3">
										<v-icon class="icon-outlined" size="20" :style="`border-color: ${scdRed}`" :color="scdRed">block</v-icon>
									</v-col>
									<v-col><div>Click abbandonato</div></v-col>
								</v-row>
							</div>
							<v-icon
								v-if="gamingAbilitato && amIAdminOrTeamleader && !datiProfiloCliccatore.iscritto_al_clickday_attuale"
								color="green"
								small
								@click="dialogIscriviCliccatoreAlClickday = true"
								class="ml-2"
							>
								mdi-plus-thick
							</v-icon>
							<v-icon
								v-if="gamingAbilitato && amIAdminOrTeamleader && datiProfiloCliccatore.iscritto_al_clickday_attuale"
								color="green"
								small
								@click="apriDialogModificaEsitoClickday()"
								class="ml-2"
							>
								edit
							</v-icon>
						</div>
						<div
							style="font-size:15px; font-weight:600;"
							class="mb-2 mt-2"
						>
							{{ esitoClickdayMessage }}
						</div>
						
						<template v-if="datiProfiloCliccatore.iscritto_al_clickday_attuale">
							<div style="font-size:14px; font-weight:500;">
								<span class="mr-2">Il tuo tempo è:</span>
								<span :style="`font-weight:600; color:${scdColorStrong};`"> {{ tempoClickdayNelRiquadro }}</span>
							</div>
							<div style="font-size:14px; font-weight:500;">
								<span class="mr-2">Compenso esiti provvisori:</span>
								<span :style="`font-weight:600; color:${scdColorStrong};`">{{ datiProfiloCliccatore.compenso_finale_esiti_provvisori_da_pagare }} €</span>
							</div>
							<div style="font-size:14px; font-weight:500;">
								<span class="mr-2">Compenso esiti definitivi:</span>
								<span :style="`font-weight:600; color:${scdColorStrong};`">{{ datiProfiloCliccatore.compenso_finale_esiti_definitivi_da_pagare }} €</span>
							</div>
							<div style="font-size:14px; font-weight:500;">
								<span class="mr-2">Differenza compensi:</span>
								<span :style="`font-weight:600; color:${scdColorStrong};`">{{ datiProfiloCliccatore.differenza_compensi_da_pagare }} €</span>
							</div>
							<div style="font-size:14px; font-weight:500;">
								<span class="mr-2">Stato pagamento compenso: </span>
								<span :style="`font-weight:600; color:${scdColor};`">
										{{ datiProfiloCliccatore.stato_pagamento_compenso ? datiProfiloCliccatore.stato_pagamento_compenso : '--------'  }}
									</span>
							</div>
							<div style="font-size:14px; font-weight:500;">
								<span class="mr-2">Data bonifico: </span>
								<span :style="`font-weight:600; color:${scdColor};`">
										{{ datiProfiloCliccatore.data_bonifico ? dateITFormatDDMMYYYY(datiProfiloCliccatore.data_bonifico) : '--------'  }}
									</span>
							</div>
							<div style="font-size:14px; font-weight:500;">
								<span class="mr-2">Note compenso:</span>
								<span :style="`font-weight:600; color:${scdColor};`">
									{{ datiProfiloCliccatore.note_compenso ? datiProfiloCliccatore.note_compenso : '--------'  }}
								</span>
							</div>
						</template>
					</div>
					
					<div
						v-if="datiProfiloCliccatore.id_bando == 28 && (datiProfiloCliccatore.path_ricevuta_click_day !== null || datiProfiloCliccatore.path_esito_rna !== null)"
						class="scatola-azzurra mb-4"
					>
						<div class="d-flex justify-space-between align-center">
							<div class="font-weight-medium mr-1">Visualizza esito Click Day</div>
							<div>
								<v-btn
									fab
									x-small
									color="blue lighten-4"
									:loading="isGettingFileEsitoClickDay"
									@click="apriFileEsitoClickDayInUnaNuovaSchedaDelBrowser()"
								>
									<v-icon color="primary">mdi-magnify</v-icon>
								</v-btn>
							</div>
						</div>
					</div>
					
					<template
						v-if="datiProfiloCliccatore.iscritto_al_clickday_attuale
							&& (
								datiProfiloCliccatore.inserire_dati_di_fatturazione_esiti_provvisori_entro_data !== null
									|| datiProfiloCliccatore.inserire_dati_di_fatturazione_esiti_provvisori_entro_giorni !== null
									|| datiProfiloCliccatore.inserire_dati_di_fatturazione_esiti_definitivi_entro_data !== null
									|| datiProfiloCliccatore.inserire_dati_di_fatturazione_esiti_definitivi_entro_giorni !== null
								)"
					>
						<v-badge
							bordered
							:color="datiProfiloCliccatore.dati_inseriti ? 'success' : 'warning'"
							:icon="datiProfiloCliccatore.dati_inseriti ? 'mdi-check' : 'mdi-exclamation'"
							overlap
							left
							class="scatola-azzurra mb-4"
						>
							<div class="d-flex flex-column">
								<template v-if="!datiProfiloCliccatore.dati_inseriti">
									<div class="font-weight-medium mb-2">
										Inserisci i dati di fatturazione richiesti e poi carica la Ricevuta/Fattura
									</div>
									<v-btn
										rounded
										color="primary"
										style="text-transform:none"
										class="btn-wrap-text"
										@click="apriDialogDatiDiFatturazione()"
									>
										Inserisci
									</v-btn>
								</template>
								
								<template v-if="datiProfiloCliccatore.dati_inseriti">
									<div class="mb-1 font-weight-medium">
										IBAN: <span :style="`color: ${$vuetify.theme.currentTheme.primary}`">{{ datiProfiloCliccatore.iban }}</span>
									</div>
									
									<div
										v-if="datiProfiloCliccatore.codice_fiscale"
										class="mb-4 font-weight-medium"
									>
										CODICE FISCALE: <span :style="`color: ${$vuetify.theme.currentTheme.primary}`">{{ datiProfiloCliccatore.codice_fiscale }}</span>
									</div>
									
									<!--TODO: serve ?-->
									<div
										v-if="datiProfiloCliccatore.partita_iva"
										class="mb-4 font-weight-medium"
									>
										PARTITA IVA: <span :style="`color: ${$vuetify.theme.currentTheme.primary}`">{{ datiProfiloCliccatore.partita_iva }}</span>
									</div>
								</template>
								
								<div v-if="datiProfiloCliccatore.dati_inseriti" class="d-flex align-center mb-4">
									<div class="mr-4 font-weight-medium">Modifica dati di fatturazione</div>
									<v-btn
										fab
										x-small
										color="yellow lighten-4"
										@click="apriDialogDatiDiFatturazione()"
									>
										<v-icon color="yellow darken-3">mdi-pencil</v-icon>
									</v-btn>
								</div>
								
								<template v-if="datiProfiloCliccatore.dati_inseriti && !datiProfiloCliccatore.possesso_partita_iva">
									<template v-if="datiProfiloCliccatore.compenso_finale_esiti_provvisori_da_pagare > 0">
										<div class="mb-2 font-weight-medium">
											Ricevuta PDF precompilata <span class="font-weight-bold">compenso esiti provvisori</span>
										</div>
										<v-btn
											rounded
											color="primary"
											style="text-transform:none"
											class="mb-5"
											@click="apriDialogScaricaModelloRicevuta(datiProfiloCliccatore.compenso_finale_esiti_provvisori_da_pagare, 'esiti_provvisori')"
										>
											<span class="mr-1">Scarica</span>
											<v-icon small>mdi-download</v-icon>
										</v-btn>
									</template>
									
									<template v-if="datiProfiloCliccatore.differenza_compensi_da_pagare > 0">
										<div class="mb-2">
											Ricevuta PDF precompilata <span class="font-weight-bold">compenso differenza esiti definitivi</span>
										</div>
										<v-btn
											rounded
											color="primary"
											style="text-transform:none"
											class="btn-wrap-text"
											@click="apriDialogScaricaModelloRicevuta(datiProfiloCliccatore.differenza_compensi_da_pagare, 'esiti_definitivi')"
										>
											<span class="mr-1">Scarica</span>
											<v-icon small>mdi-download</v-icon>
										</v-btn>
									</template>
								</template>
							
							</div>
						</v-badge>
						
						<v-badge
							:value="datiProfiloCliccatore.compenso_finale_esiti_provvisori_da_pagare > 0"
							bordered
							:color="datiProfiloCliccatore.path_ricevuta_o_fattura_esiti_provvisori === null
								&& datiProfiloCliccatore.compenso_finale_esiti_provvisori_da_pagare > 0
									? 'warning'
									: 'success'"
							:icon="datiProfiloCliccatore.path_ricevuta_o_fattura_esiti_provvisori === null
								&& datiProfiloCliccatore.compenso_finale_esiti_provvisori_da_pagare > 0
									? 'mdi-exclamation'
									: 'mdi-check'"
							overlap
							left
							class="scatola-azzurra mb-4"
						>
							<div class="d-flex flex-column ">
								<v-alert
									v-if="datiProfiloCliccatore.path_ricevuta_o_fattura_esiti_provvisori === null
										&& datiProfiloCliccatore.compenso_finale_esiti_provvisori_da_pagare > 0"
									class="mb-4"
									color="warning"
								>
									<div class="mb-1 font-weight-bold">PAGAMENTO NON EROGABILE A CAUSA DI DATI MANCANTI</div>
									<div class="font-weight-medium">Caricare i dati di pagamento richiesti e la Ricevuta/Fattura entro {{ inserireDatiDiFatturazioneEsitiProvvisoriEntro }} seguendo <a :style="`color: ${scdColorStrong}`" target="_blank" href="https://docs.google.com/document/d/1vGuhOzwRkECMSBMeHpPqewhPqh46YdnMpsiv1r97icM/edit">questa procedura</a>. In caso contrario, verrà considerata come una rinuncia implicita al pagamento, come previsto dal contratto.</div>
								</v-alert>
								
								<v-alert
									v-if="datiProfiloCliccatore.path_ricevuta_o_fattura_esiti_provvisori !== null
										&& datiProfiloCliccatore.compenso_finale_esiti_provvisori_da_pagare > 0"
									class="mb-4"
									color="success"
								>
									<div class="mb-1 font-weight-bold">DATI CARICATI CORRETTAMENTE</div>
									<div class="font-weight-medium">Riceverai il compenso degli esiti provvisori tramite bonifico bancario entro {{ pagamentoCompensoEsitiProvvisoriEntro }}.</div>
								</v-alert>
								
								<div class="d-flex justify-space-between align-center">
									<div class="font-weight-medium mr-1">Ricevuta o Fattura Esiti Provvisori</div>
									<div>
										<v-btn
											fab
											x-small
											color="green lighten-4"
											class="mr-1"
											:loading="isSelectingRicevutaOFatturaEsitiProvvisori || isUploadingRicevutaOFatturaEsitiProvvisori"
											:disabled="datiProfiloCliccatore.compenso_finale_esiti_provvisori_da_pagare == 0
												|| !datiProfiloCliccatore.dati_inseriti"
											@click="handleFileRicevutaOFatturaEsitiProvvisoriImport()"
										>
											<v-icon color="green darken-3">mdi-upload</v-icon>
										</v-btn>
										
										<input
											ref="ricevutaOFatturaEsitiProvvisoriUploader"
											class="d-none"
											type="file"
											accept="application/pdf"
											@change="onFileRicevutaOFatturaEsitiProvvisoriChanged($event)"
										>
										
										<v-btn
											fab
											x-small
											color="blue lighten-4"
											:disabled="datiProfiloCliccatore.path_ricevuta_o_fattura_esiti_provvisori === null
												|| isUploadingRicevutaOFatturaEsitiProvvisori"
											:loading="isGettingRicevutaOFatturaEsitiProvvisori"
											@click="apriRicevutaOFatturaEsitiProvvisoriInUnaNuovaSchedaDelBrowser()"
										>
											<v-icon color="primary">mdi-magnify</v-icon>
										</v-btn>
									</div>
								</div>
								
								<v-alert
									type="error"
									:value="alertRicevutaOFatturaEsitiProvvisoriCaricataNonValida"
									transition="scale-transition"
									class="mt-4"
								>
									Il file caricato non è valido.<br>
									Assicurati che sia in formato PDF.
								</v-alert>
							</div>
						</v-badge>
						
						<v-badge
							:value="datiProfiloCliccatore.differenza_compensi_da_pagare > 0"
							bordered
							:color="datiProfiloCliccatore.path_ricevuta_o_fattura_esiti_definitivi === null
								&& datiProfiloCliccatore.differenza_compensi_da_pagare > 0
									? 'warning'
									: 'success'"
							:icon="datiProfiloCliccatore.path_ricevuta_o_fattura_esiti_definitivi === null
								&& datiProfiloCliccatore.differenza_compensi_da_pagare > 0
									? 'mdi-exclamation'
									: 'mdi-check'"
							overlap
							left
							class="scatola-azzurra"
						>
							<div class="d-flex flex-column">
								<v-alert
									v-if="datiProfiloCliccatore.path_ricevuta_o_fattura_esiti_definitivi === null
										&& datiProfiloCliccatore.differenza_compensi_da_pagare > 0"
									class="mb-4"
									color="warning"
								>
									<div class="mb-1 font-weight-bold">PAGAMENTO NON EROGABILE A CAUSA DI DATI MANCANTI</div>
									<div class="font-weight-medium">Caricare i dati di pagamento richiesti e la Ricevuta/Fattura entro {{ inserireDatiDiFatturazioneEsitiDefinitiviEntro }} seguendo <a :style="`color: ${scdColorStrong}`" target="_blank" href="https://docs.google.com/document/d/1giYYm-4I3BbOOhjm2tpGzoX48xItVigulYw0DpiAlPs/edit?tab=t.0#heading=h.nuctkh2hu0a7">questa procedura</a>. In caso contrario, verrà considerata come una rinuncia implicita al pagamento, come previsto dal contratto.</div>
								</v-alert>
								
								<v-alert
									v-if="datiProfiloCliccatore.path_ricevuta_o_fattura_esiti_definitivi !== null
										&& datiProfiloCliccatore.differenza_compensi_da_pagare > 0"
									class="mb-4"
									color="success"
								>
									<div class="mb-1 font-weight-bold">DATI CARICATI CORRETTAMENTE</div>
									<div class="font-weight-medium">Riceverai il compenso degli esiti definitivi tramite bonifico bancario entro {{ pagamentoCompensoEsitiDefinitiviEntro }}</div>
								</v-alert>
								
								<div class="d-flex justify-space-between align-center">
									<div class="font-weight-medium mr-1">Ricevuta o Fattura Esiti Definitivi</div>
									<div>
										<v-btn
											fab
											x-small
											color="green lighten-4"
											class="mr-1"
											:loading="isSelectingRicevutaOFatturaEsitiDefinitivi || isUploadingRicevutaOFatturaEsitiDefinitivi"
											:disabled="datiProfiloCliccatore.differenza_compensi_da_pagare <= 0 || !datiProfiloCliccatore.dati_inseriti"
											@click="handleFileRicevutaOFatturaEsitiDefinitiviImport()"
										>
											<v-icon color="green darken-3">mdi-upload</v-icon>
										</v-btn>
										
										<input
											ref="ricevutaOFatturaEsitiDefinitiviUploader"
											class="d-none"
											type="file"
											accept="application/pdf"
											@change="onFileRicevutaOFatturaEsitiDefinitiviChanged($event)"
										>
										
										<v-btn
											fab
											x-small
											color="blue lighten-4"
											:disabled="datiProfiloCliccatore.path_ricevuta_o_fattura_esiti_definitivi === null
												|| isUploadingRicevutaOFatturaEsitiDefinitivi"
											:loading="isGettingRicevutaOFatturaEsitiDefinitivi"
											@click="apriRicevutaOFatturaEsitiDefinitiviInUnaNuovaSchedaDelBrowser()"
										>
											<v-icon color="primary">mdi-magnify</v-icon>
										</v-btn>
									</div>
								</div>
								
								<v-alert
									type="error"
									:value="alertRicevutaOFatturaEsitiDefinitiviCaricataNonValida"
									transition="scale-transition"
									class="mt-4"
								>
									Il file caricato non è valido.<br>
									Assicurati che sia in formato PDF.
								</v-alert>
							</div>
						</v-badge>
					</template>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col>
					<div
						v-if="(amIAdminOrTeamleader || computedAmIDeveloper) && computedClienteClickdayIt && !idCliccatore"
						class="d-flex mt-4"
					>
						<div v-if="computedAmIDeveloper || amIAdminOrTeamleader">
							<v-btn
								rounded
								depressed
								style="text-transform:none; color:white;"
								@click="apriDialogGestioneScreenshotsEdEsiti()"
								:color="scdGreen"
							>
								Gestione Screenshots ed Esiti
							</v-btn>
						</div>
					</div>
				</v-col>
			</v-row>
		</div>
		
		<v-dialog
			v-model="dialogModificaEsitoClickday"
			max-width="580"
			persistent
		>
			<modifica-esito-clickday-component
				:key="dialogModificaEsitoClickdayKey"
				:dati-esito-clickday="datiModificaEsitoClickday"
				:bando-id="datiProfiloCliccatore.id_bando"
				@dati-esito-clickday-aggiornati="handleDatiEsitoClickDayAggiornati()"
				@chiudi-dialog="dialogModificaEsitoClickday = false"
			></modifica-esito-clickday-component>
		</v-dialog>
		
		<v-dialog
			v-model="dialogIscriviCliccatoreAlClickday"
			max-width="580"
			persistent
		>
			<v-card>
				<v-card-title>
					<div style="font-weight:600 !important;">
						Iscrivere il Cliccatore al Click Day?
					</div>
				</v-card-title>
				<v-card-text>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						class="px-4 mr-2 white--text"
						style="text-transform:none;"
						depressed
						rounded
						:color="scdColor"
						@click="dialogIscriviCliccatoreAlClickday = false"
						:disabled="iscrizioneAlClickdayInCorso"
					>
						Annulla
					</v-btn>
					<v-btn
						class="px-4 white--text"
						style="text-transform:none;"
						depressed
						rounded
						:color="scdOrange"
						@click="iscriviCliccatoreAlClickday()"
						:loading="iscrizioneAlClickdayInCorso"
					>
						Iscrivi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<v-dialog
			v-model="dialogGestioneScreenshotsEdEsiti"
			persistent
			scrollable
		>
			<gestione-screenshot-ed-esiti-component
				:key="gestioneScreenshotsEdEsitiKey"
				:id-bando="datiProfiloCliccatore.id_bando"
				:nome-bando="datiProfiloCliccatore.nome_bando"
				@close="dialogGestioneScreenshotsEdEsiti = false"
			></gestione-screenshot-ed-esiti-component>
		</v-dialog>
		
		<v-dialog
			v-model="dialogDatiDiFatturazione"
			persistent
			scrollable
			width="1000px"
		>
			<dati-di-fatturazione-component
				:key="dialogDatiDiFatturazioneKey"
				:value="datiProfiloCliccatore"
				:id-cliccatore="idCliccatore"
				:bando-id="bandoId"
				@close="dialogDatiDiFatturazione = false"
				@salvataggio-eseguito="handleSalvataggioDatiDiFatturazioneEseguito()"
			></dati-di-fatturazione-component>
		</v-dialog>
		
		<v-dialog
			v-model="dialogNumeroProgressivoRicevuta"
			:key="dialogNumeroProgressivoRicevutaKey"
			persistent
			scrollable
			width="500px"
		>
			<v-card>
				<v-card-title></v-card-title>
				<v-card-text>
					<v-row>
						<v-col>
							<div class="font-weight-medium black--text">
								Inserisci qui sotto il numero della ricevuta. Metti 1 se è la prima ricevuta che emetti nel 2024, 2 se è la seconda e via dicendo.
							</div>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="5">
							<v-form ref="numeroProgressivoForm">
								<v-text-field
									v-model="numeroProgressivoRicevuta"
									type="number"
									min="1"
									:rules="[vincoli.required, vincoli.isNumber]"
									outlined
									dense
								>
								</v-text-field>
							</v-form>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						:color="scdRed"
						class="white--text"
						rounded
						@click="dialogNumeroProgressivoRicevuta = false"
						:disabled="downloadPdfModelloRicevutaInCorso"
					>
						Annulla
					</v-btn>
					<v-btn
						rounded
						style="text-transform:none; color:white;"
						@click="scaricaPdfModelloRicevuta()"
						:color="scdOrange"
						:loading="downloadPdfModelloRicevutaInCorso"
					>
						Scarica
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
	</div>
</template>

<script>
import mixin from '../../mixins';
import { saveAs } from 'file-saver';

export default {
	props: {
		// se value !== null sta ricevendo i dati del profilo cliccatore dall'esterno
		// e non devo chiamare il metodo getProfiloCliccatore() in questo componente
		value: {
			default: null
		},
		isLoading: {
			default: false
		},
		idCliccatore: {
			default: null
		},
		bandoId: {
			default: null
		}
	},
	
	data() {
		return {
			isLoadingProfiloCliccatore: false,
			datiProfiloCliccatore: {},
			
			dialogIscriviCliccatoreAlClickday: false,
			iscrizioneAlClickdayInCorso: false,
			
			dialogGestioneScreenshotsEdEsiti: false,
			gestioneScreenshotsEdEsitiKey: 0,
			
			dialogModificaEsitoClickdayKey: 0,
			dialogModificaEsitoClickday: false,
			datiModificaEsitoClickday: {
				idCliccatore: null,
				esitoClickday: null,
				tempoClickday: null,
				compensoFinalePersonalizzatoEsitiProvvisori: null,
				compensoFinalePersonalizzatoEsitiDefinitivi: null,
				noteCompenso: null,
				statoPagamentoCompenso: null
			},
			
			dialogDatiDiFatturazione: false,
			dialogDatiDiFatturazioneKey: 0,
			
			compensoPerModelloRicevuta: null,
			tipoEsitiPerModelloRicevuta: null,
			numeroProgressivoRicevuta: null,
			dialogNumeroProgressivoRicevuta: false,
			dialogNumeroProgressivoRicevutaKey: 0,
			downloadPdfModelloRicevutaInCorso: false,
			
			ricevutaOFatturaEsitiProvvisori: null, // file pdf
			isSelectingRicevutaOFatturaEsitiProvvisori: false,
			isUploadingRicevutaOFatturaEsitiProvvisori: false,
			isGettingRicevutaOFatturaEsitiProvvisori: false,
			alertRicevutaOFatturaEsitiProvvisoriCaricataNonValida: false,
			
			ricevutaOFatturaEsitiDefinitivi: null, // file pdf
			isSelectingRicevutaOFatturaEsitiDefinitivi: false,
			isUploadingRicevutaOFatturaEsitiDefinitivi: false,
			isGettingRicevutaOFatturaEsitiDefinitivi: false,
			alertRicevutaOFatturaEsitiDefinitiviCaricataNonValida: false,
			
			isGettingFileEsitoClickDay: false
		}
	},
	
	async created() {
		if (this.value !== null) { // se sto ricevendo i dai del profilo cliccatore via prop
			this.datiProfiloCliccatore = Object.assign({}, this.value);
		}
		else { // altrimenti prendo i dati dal metodo in questo componente
			await this.getProfiloCliccatore();
		}
		
		// se è il Bando Inail 2020 devo aggiungere al compenso finale il bonus dei livelli
		if (this.datiProfiloCliccatore.id_bando === 1) {
			const data = this.getLivello(this.datiProfiloCliccatore.miglior_punteggio/*.punteggio*/); // dal mixins
			// this.livelloCliccatore = data.livello;
			this.datiProfiloCliccatore.compenso_vittoria += data.bonusVittoria;
			this.datiProfiloCliccatore.compenso_perdita += data.bonusPerdita;
		}
	},
	
	computed: {
		// TODO: verificare se funziona
		tempoClickdayNelRiquadro() {
			if (this.datiProfiloCliccatore.esito_clickday == 'Vincente'
				|| this.datiProfiloCliccatore.esito_clickday == 'Vincente Esiti Definitivi'
				|| this.datiProfiloCliccatore.esito_clickday == 'Non vincente'
			) {
				return this.datiProfiloCliccatore.tempo_clickday;
			}
			else return '--.---';
		},
		esitoClickdayMessage() {
			return this.datiProfiloCliccatore.esito_clickday === 'Vincente'
				|| this.datiProfiloCliccatore.esito_clickday === 'Vincente Esiti Definitivi'
				? 'Congratulazioni per aver vinto il Click Day!'
				: (this.datiProfiloCliccatore.esito_clickday === 'Non vincente'
						? 'Purtroppo il tuo Click non è risultato vincente'
						: null
				)
		},
		inserireDatiDiFatturazioneEsitiProvvisoriEntro() {
			if (this.datiProfiloCliccatore.inserire_dati_di_fatturazione_esiti_provvisori_entro_data !== null) {
				return `il ${this.dateITFormatDDMMYYYY(this.datiProfiloCliccatore.inserire_dati_di_fatturazione_esiti_provvisori_entro_data)}`;
			}
			else if (this.datiProfiloCliccatore.inserire_dati_di_fatturazione_esiti_provvisori_entro_giorni !== null) {
				return `${this.datiProfiloCliccatore.inserire_dati_di_fatturazione_esiti_provvisori_entro_giorni} giorni dalla pubblicazione degli elenchi cronologici provvisori`;
			}
			else return `-- giorni dalla pubblicazione degli elenchi cronologici provvisori`;
		},
		inserireDatiDiFatturazioneEsitiDefinitiviEntro() {
			if (this.datiProfiloCliccatore.inserire_dati_di_fatturazione_esiti_definitivi_entro_data !== null) {
				return `il ${this.dateITFormatDDMMYYYY(this.datiProfiloCliccatore.inserire_dati_di_fatturazione_esiti_definitivi_entro_data)}`;
			}
			else if (this.datiProfiloCliccatore.inserire_dati_di_fatturazione_esiti_definitivi_entro_giorni !== null) {
				return `${this.datiProfiloCliccatore.inserire_dati_di_fatturazione_esiti_definitivi_entro_giorni} giorni dalla pubblicazione degli elenchi cronologici definitivi`;
			}
			else return `-- giorni dalla pubblicazione degli elenchi cronologici definitivi`;
		},
		pagamentoCompensoEsitiProvvisoriEntro() {
			if (this.datiProfiloCliccatore.pagamento_compenso_esiti_provvisori_entro_data !== null) {
				return `il ${this.dateITFormatDDMMYYYY(this.datiProfiloCliccatore.pagamento_compenso_esiti_provvisori_entro_data)}`
			}
			else return '60 giorni dalla pubblicazione degli elenchi cronologici provvisori'
		},
		pagamentoCompensoEsitiDefinitiviEntro() {
			if (this.datiProfiloCliccatore.pagamento_compenso_esiti_definitivi_entro_data !== null) {
				return `il ${this.dateITFormatDDMMYYYY(this.datiProfiloCliccatore.pagamento_compenso_esiti_definitivi_entro_data)}`
			}
			else return '60 giorni dalla pubblicazione degli elenchi cronologici definitivi'
		}
	},
	
	methods: {
		handleSalvataggioDatiDiFatturazioneEseguito() {
			// se ho ricevuto i dati del profilo cliccatore dalla prop value allora rispondo con $emit
			if (this.value !== null) {
				this.$emit('salvataggio-dati-di-fatturazione-eseguito');
			}
			// altrimenti significa che i dati del profilo li ho ottenuti dal metodo getProfiloCliccatore quindi lo chiamo nuovamente per ricevere i dati aggiornati
			else {
				this.getProfiloCliccatore()
			}
		},
		handleDatiEsitoClickDayAggiornati() {
			// se ho ricevuto i dati del profilo cliccatore dalla prop value allora rispondo con $emit
			if (this.value !== null) {
				this.$emit('dati-esito-clickday-aggiornati');
			}
			// altrimenti significa che i dati del profilo li ho ottenuti dal metodo getProfiloCliccatore quindi lo chiamo nuovamente per ricevere i dati aggiornati
			else {
				this.getProfiloCliccatore()
			}
		},
		handleIscriviCliccatoreAlClickday() {
			// se ho ricevuto i dati del profilo cliccatore dalla prop value allora rispondo con $emit
			if (this.value !== null) {
				this.$emit('cliccatore-iscritto');
			}
			// altrimenti significa che i dati del profilo li ho ottenuti dal metodo getProfiloCliccatore quindi lo chiamo nuovamente per ricevere i dati aggiornati
			else {
				this.getProfiloCliccatore()
			}
		},
		/**
		 * TODO: per ora questo metodo viene chiamato solo quando questo componente viene usato nella pagina Click Day
		 *  dovrei usarlo anche nella pagina Dashboard ma prima devo trovare il modo spezzettare il metodo getProfiloCliccatore nel backend
		 */
		getProfiloCliccatore() {
			this.isLoadingProfiloCliccatore = true;
			
			return axios.get(this.idCliccatore
					? '/clickdayit/get_profilo_cliccatore/' + this.idCliccatore
					: '/clickdayit/get_profilo_cliccatore',
				{
					params: {
						bandoId: this.bandoId
					}
				}
			)
				.then(response => {
					this.datiProfiloCliccatore = response.data;
				})
				.finally(() => {
					this.isLoadingProfiloCliccatore = false;
				});
		},
		apriDialogModificaEsitoClickday() {
			this.dialogModificaEsitoClickdayKey++;
			
			this.datiModificaEsitoClickday = {
				idCliccatore: this.idCliccatore, // diverso da null solo se è stato passato via prop
				bandoId: this.bandoId, // // diverso da null solo se è stato passato via prop
				esitoClickday: this.datiProfiloCliccatore.esito_clickday,
				tempoClickday: this.datiProfiloCliccatore.tempo_clickday,
				compensoFinalePersonalizzatoEsitiProvvisori:
					this.datiProfiloCliccatore.compenso_finale_personalizzato_esiti_provvisori !== null
						? this.datiProfiloCliccatore.compenso_finale_personalizzato_esiti_provvisori
						: null,
				compensoFinalePersonalizzatoEsitiDefinitivi:
					this.datiProfiloCliccatore.compenso_finale_personalizzato_esiti_definitivi !== null
						? this.datiProfiloCliccatore.compenso_finale_personalizzato_esiti_definitivi
						: null,
				statoPagamentoCompenso: this.datiProfiloCliccatore.stato_pagamento_compenso,
				noteCompenso: this.datiProfiloCliccatore.note_compenso,
				dataDelBonifico: this.datiProfiloCliccatore.data_bonifico,
				codiceCliccatore: this.datiProfiloCliccatore.codice_cliccatore,
				nomeInDatiDiFatturazione: this.datiProfiloCliccatore.nome_in_dati_di_fatturazione,
				cognomeInDatiDiFatturazione: this.datiProfiloCliccatore.cognome_in_dati_di_fatturazione
			}
			
			this.dialogModificaEsitoClickday = true;
		},
		iscriviCliccatoreAlClickday() {
			this.iscrizioneAlClickdayInCorso = true;
			
			const url = this.idCliccatore
				? `/iscriviCliccatoreAlClickday/${this.idCliccatore}`
				: '/iscriviCliccatoreAlClickday';
			
			axios.get(url, {
				params: {
					bando_id: this.bandoId
				}
			})
				.then(() => {
					this.handleIscriviCliccatoreAlClickday();
				})
				.finally(() => {
					this.iscrizioneAlClickdayInCorso = false;
					this.dialogIscriviCliccatoreAlClickday = false;
				})
		},
		apriDialogGestioneScreenshotsEdEsiti() {
			this.dialogGestioneScreenshotsEdEsiti = true;
			this.gestioneScreenshotsEdEsitiKey++;
		},
		apriDialogDatiDiFatturazione() {
			this.dialogDatiDiFatturazioneKey++;
			this.dialogDatiDiFatturazione = true;
		},
		apriDialogScaricaModelloRicevuta(compenso, tipoEsiti) {
			this.tipoEsitiPerModelloRicevuta = tipoEsiti; // 'esiti_provvisori' o 'esiti_definitivi'
			this.compensoPerModelloRicevuta = compenso;
			this.dialogNumeroProgressivoRicevutaKey++;
			this.dialogNumeroProgressivoRicevuta = true;
		},
		scaricaPdfModelloRicevuta() {
			if (!this.$refs.numeroProgressivoForm.validate()) return;
			
			this.downloadPdfModelloRicevutaInCorso = true;
			axios.get('/clickdayit/pdf-ricevuta-prestazione-occasionale', {
				responseType: 'blob',
				params: {
					utente_id: this.idCliccatore, // presente solo se è stato passato via prop, altrimenti verrà preso il cliccatore loggato
					bando_id: this.bandoId, // presente solo se è stato passato via prop, altrimenti verrà preso il bando impostato dal cliente
					compenso: this.compensoPerModelloRicevuta,
					numero_progressivo_ricevuta: this.numeroProgressivoRicevuta,
					tipo_esiti: this.tipoEsitiPerModelloRicevuta
				}
			})
				.then(response => {
					saveAs(response.data, `Ricevuta di prestazione occasionale ${this.datiProfiloCliccatore.nome_bando} ${this.datiProfiloCliccatore.nome_in_dati_di_fatturazione} ${this.datiProfiloCliccatore.cognome_in_dati_di_fatturazione}.pdf`);
				})
				.finally(() => {
					this.downloadPdfModelloRicevutaInCorso = false;
				})
		},
		handleFileRicevutaOFatturaEsitiProvvisoriImport() {
			this.isSelectingRicevutaOFatturaEsitiProvvisori = true;
			// After obtaining the focus when closing the FilePicker, return the button state to normal
			window.addEventListener('focus', () => {
				this.isSelectingRicevutaOFatturaEsitiProvvisori = false
			}, { once: true });
			
			// Trigger click on the FileInput
			this.$refs.ricevutaOFatturaEsitiProvvisoriUploader.click();
		},
		uploadRicevutaOFatturaEsitiProvvisori() {
			this.isUploadingRicevutaOFatturaEsitiProvvisori = true;
			
			let formData = new FormData();
			formData.append('ricevuta_o_fattura', this.ricevutaOFatturaEsitiProvvisori);
			if (this.idCliccatore) formData.append('utente_id', this.idCliccatore);
			formData.append('bando_id', this.datiProfiloCliccatore.id_bando);
			
			axios.post('/cliccatori/upload-ricevuta-o-fattura', formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.datiProfiloCliccatore.path_ricevuta_o_fattura_esiti_provvisori = response.data;
				})
				.catch(error => {
					if (error.response.status == 422) {
						this.alertRicevutaOFatturaEsitiProvvisoriCaricataNonValida = true;
						setTimeout(() => {
							this.alertRicevutaOFatturaEsitiProvvisoriCaricataNonValida = false
						},10000)
					}
					console.log(error.response.status)
				})
				.finally(() => {
					this.isUploadingRicevutaOFatturaEsitiProvvisori = false;
				})
		},
		onFileRicevutaOFatturaEsitiProvvisoriChanged(e) {
			this.ricevutaOFatturaEsitiProvvisori = e.target.files[0];
			// Do whatever you need with the file, like reading it with FileReader
			this.uploadRicevutaOFatturaEsitiProvvisori();
		},
		apriRicevutaOFatturaEsitiProvvisoriInUnaNuovaSchedaDelBrowser() {
			this.isGettingRicevutaOFatturaEsitiProvvisori = true;
			axios.post('/cliccatori/get-ricevuta-o-fattura', {
				path_ricevuta_o_fattura: this.datiProfiloCliccatore.path_ricevuta_o_fattura_esiti_provvisori
			}, {
				responseType: 'arraybuffer'
			})
				.then(response => {
					// this.ricevutaPdf = response.data;
					const file = new Blob([response.data], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(file);
					window.open(fileURL);
				})
				.finally(() => {
					this.isGettingRicevutaOFatturaEsitiProvvisori = false;
				})
		},
		handleFileRicevutaOFatturaEsitiDefinitiviImport() {
			this.isSelectingRicevutaOFatturaEsitiDefinitivi = true;
			// After obtaining the focus when closing the FilePicker, return the button state to normal
			window.addEventListener('focus', () => {
				this.isSelectingRicevutaOFatturaEsitiDefinitivi = false
			}, { once: true });
			
			// Trigger click on the FileInput
			this.$refs.ricevutaOFatturaEsitiDefinitiviUploader.click();
		},
		uploadRicevutaOFatturaEsitiDefinitivi() {
			this.isUploadingRicevutaOFatturaEsitiDefinitivi = true;
			
			let formData = new FormData();
			formData.append('ricevuta_o_fattura_esiti_definitivi', this.ricevutaOFatturaEsitiDefinitivi);
			if (this.idCliccatore) formData.append('utente_id', this.idCliccatore);
			formData.append('bando_id', this.datiProfiloCliccatore.id_bando);
			axios.post('/cliccatori/upload-ricevuta-o-fattura-esiti-definitivi', formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.datiProfiloCliccatore.path_ricevuta_o_fattura_esiti_definitivi = response.data;
				})
				.catch(error => {
					if (error.response.status == 422) {
						this.alertRicevutaOFatturaEsitiDefinitiviCaricataNonValida = true;
						setTimeout(() => {
							this.alertRicevutaOFatturaEsitiDefinitiviCaricataNonValida = false
						},10000)
					}
				})
				.finally(() => {
					this.isUploadingRicevutaOFatturaEsitiDefinitivi = false;
				})
		},
		onFileRicevutaOFatturaEsitiDefinitiviChanged(e) {
			this.ricevutaOFatturaEsitiDefinitivi = e.target.files[0];
			// Do whatever you need with the file, like reading it with FileReader
			this.uploadRicevutaOFatturaEsitiDefinitivi();
		},
		apriRicevutaOFatturaEsitiDefinitiviInUnaNuovaSchedaDelBrowser() {
			this.isGettingRicevutaOFatturaEsitiDefinitivi = true;
			axios.post('/cliccatori/get-ricevuta-o-fattura-esiti-definitivi', {
				path_ricevuta_o_fattura_esiti_definitivi: this.datiProfiloCliccatore.path_ricevuta_o_fattura_esiti_definitivi
			}, {
				responseType: 'arraybuffer'
			})
				.then(response => {
					// this.ricevutaPdf = response.data;
					const file = new Blob([response.data], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(file);
					window.open(fileURL);
				})
				.finally(() => {
					this.isGettingRicevutaOFatturaEsitiDefinitivi = false;
				})
		},
		apriFileEsitoClickDayInUnaNuovaSchedaDelBrowser() {
			this.isGettingFileEsitoClickDay = true;
			
			let url = null
			let pathKey = null;
			let path = null;
			
			if (this.datiProfiloCliccatore.path_ricevuta_click_day !== null) {
				url = '/bandi/get-ricevuta-esito-click-day';
				pathKey = 'path_ricevuta_click_day';
				path = this.datiProfiloCliccatore.path_ricevuta_click_day
			}
			else {
				url = '/bandi/get-esito-rna';
				pathKey = 'path_esito_rna';
				path = this.datiProfiloCliccatore.path_esito_rna
			}
			
			axios.post(url, {
				[pathKey]: path
			}, {
				responseType: 'arraybuffer'
			})
				.then(response => {
					// Recupera il content-type dalla risposta del server
					const contentType = response.headers['content-type'] || 'application/octet-stream';
					
					// Crea il Blob con il MIME type corretto
					const file = new Blob([response.data], { type: contentType });
					
					const fileURL = URL.createObjectURL(file);
					window.open(fileURL);
				})
				.finally(() => {
					this.isGettingFileEsitoClickDay = false;
				})
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .v-dialog {
	font-family: 'Montserrat', sans-serif !important;
	// font-size: 14px;
	// color: #6D94CD;
	// font-weight: 400;
	// line-height:1.5;
	// padding-top: 20px;
}

._box-profilo-cliccatore {
	margin: 0 30px 0 0;
	font-size: 14px;
	& div {
		font-weight: 500;
	}
	& span {
		font-weight: 600;
	}
}

._box_title {
	font-size: 16px;
	font-weight: 600;
	text-align:center;
	background-color: #6D94CD;
	padding: 5px 10px;
	color:white
}

.icon-outlined {
	background-color: white;
	border: 1px solid #3c4f6b;
	border-radius:50%;
	height: 30px;
	width: 30px;
}

.scatola-azzurra {
	padding:25px 20px;
	min-width:259px;
	width: 100%;
	background-color: #e3ebf6;
	border-radius: 10px
}
</style>